module.exports = __webpack_public_path__ + "img/java.b203332c.png";